import useStore from '@hooks/useStore';

export default function useLocale() {
  const {
    store: { locale },
  } = useStore();

  return locale;
}
